// Label-above layout for bulk-edit fields (matches taskFormStyles / TaskDateTimeFields).
import { Box } from '@mui/material';
import {
  fieldLabelSx,
  formGroupSx,
} from '@/features/tasks/components/forms/taskFormStyles';

/**
 * @param {{
 *   label: import('react').ReactNode,
 *   htmlFor?: string,
 *   labelId?: string,
 *   children: import('react').ReactNode,
 * }} props
 */
export function BulkEditFieldGroup({ label, htmlFor, labelId, children }) {
  return (
    <Box sx={formGroupSx}>
      <Box
        component="label"
        htmlFor={htmlFor}
        id={labelId}
        sx={fieldLabelSx}
      >
        {label}
      </Box>
      {children}
    </Box>
  );
}
